
$().ready(function () {
    $(".rodo").css("display","none");
    var cookieRodo = getCookie('rodo-cookie');
    if (cookieRodo === 'null'
        || cookieRodo === ""
        || cookieRodo === null
        || cookieRodo === undefined
        || cookieRodo === 'undefined') {
            $(".rodo").css("display","block");
    } else {
        $(".rodo").css("display","none");
    }

});

function closeRodoModalAndSaveCookie() {
    setCookie('rodo-cookie', 1, 30);
    $(".rodo").css("display","none");
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


$(function () {
    let nrSlider = 1;
    let nrSliderPrevious = 1;
    let animated = false;
    let _currentlyShownPartner = 1;
    let maxPartner = 1;
    $(window).scroll(function () {
        scrollWindow();
        parallax();
    });

    setSlider = function (nr) {
        nr = Number(nr);
        if (nr > 4) {
            nr = 1;
        } else if (nr < 1) {
            nr = 4;
        }
        nrSliderPrevious = nrSlider;
        nrSlider = nr;
    };

    scrollWindow = function () {
        const x = $(this).scrollTop();
        const w = $(window).width();
        let threshold = 145;
        if (w < 1550) {
            threshold = 0;
        }
        if (x >= threshold) {
            $('body').addClass('scroll');
        } else {
            $('body').removeClass('scroll');
        }
        if (x > 300) {
            $('.js-up').addClass('visible');
        } else {
            $('.js-up').removeClass('visible');
        }
    };

    $('.header-hamburger').click(function () {
        $('body').toggleClass('openMenu');
    });
    $('.js-up').click(function () {
        const body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1000, 'swing');
    });

    hideSliders = function () {
        $('.homeSlider .paginationPoints .paginationPoints-point').removeClass('active');
        $('.homeSlider-graphics .homeSlider-graphic').removeClass('active previous');
        $('.homeSlider-slogans .homeSlider-slogan').stop();
        $('.homeSlider-graphics .homeSlider-graphic img').stop();
    };

    showSlider = function () {
        hideSliders();
        $('.homeSlider .paginationPoints [data-item=' + nrSlider + ']').addClass('active');
        $('.homeSlider-graphics [data-item=' + nrSliderPrevious + ']').addClass('previous');
        $('.homeSlider-graphics [data-item=' + nrSlider + ']').addClass('active');
        const slogans = $('.homeSlider-slogans .homeSlider-slogan');
        slogans.removeClass('active');
        slogans.css({'left': 100, opacity: 0});

        const slogan = $('.homeSlider-slogans [data-item=' + nrSlider + ']');
        slogan.addClass('active');
        slogan.animate({left: 0, opacity: 1}, 2000);

        const obraz = $('.homeSlider-graphics [data-item=' + nrSlider + '] img');
        obraz.css({"opacity": 0, x: 0});
        obraz.animate({x: 200}, {
            step: function (now, fx) {
                $(this).css({
                    "transform": "perspective(2000px) translate3d(0px, 0px, " + now + "px)",
                    opacity: (now / 30)
                });
            },
            duration: 10000,
            complete: showNext,
            easing: 'linear'
        });
    };

    showNext = function () {
        const id = nrSlider + 1;
        if (nrSlider !== id) {
            setSlider(id);
            showSlider();
        }
    };

    showPrev = function () {
        const id = nrSlider - 1;
        if (nrSlider !== id) {
            setSlider(id);
            showSlider();
        }
    };

    $('.homeSlider .paginationPoints .paginationPoints-point').click(function (i, v) {
        const id = $(this).attr('data-item');
        if (nrSlider !== id) {
            setSlider(id);
            showSlider();
        }
    });
    $('.homeSlider-arrow--right').click(function () {
        showNext();
    });
    $('.homeSlider-arrow--left').click(function () {
        showPrev();
    });
    scrollWindow();
    showSlider();
    $('.homeSlider-arrowDown').click(function () {
        const body = $("html, body");
        const homeSlider = $('.homeSlider');
        const w = $(window).width();
        let margin = 0;
        if (w > 1550) {
            margin = 150;
        }
        const homeSliderPosition = homeSlider.height() + margin;
        body.stop().animate({scrollTop: homeSliderPosition}, 1000, 'swing');
    });

    parallax = function () {
        let scrolled = $(window).scrollTop();
        let el = $('.parallax');
        el.each(function () {
            let y = $(this).offset().top;
            let parallax = (scrolled - y) * $(this).data('speed');
            $(this).css({
                'top': parallax
            });
        });
    };
    setClickParentSlider = function () {
        $('.partnersSlider-points .paginationPoints-point').click(function () {
            const sought = Number($(this).data('item'));
            movePartnersSlider(sought);
            selectedPointSlider();
        });
    };

    setCurrentlyShownPartner = function(nr) {
        if (nr > maxPartner) {
            nr = maxPartner;
        }
        if (nr < 1) {
            nr = 1;
        }
        _currentlyShownPartner = nr;
    };

    movePartnersSlider = function (nr) {
        setCurrentlyShownPartner(nr);
        const widthLogos = $('.partnersSlider .partnersSlider-items').width();
        let pozX = (_currentlyShownPartner - 1) * widthLogos;
        $('.partnersSlider-items').animate({left: -pozX}, 500);
    };
    addPointPartners = function (nr) {
        for (let i = 1; i <= nr; i++) {
            const classA = (i === 1) ? 'active' : '';
            const point = "<div class='paginationPoints-point " + classA + "' data-item='" + i + "'></div>";
            $('.partnersSlider-points .paginationPoints').append(point);
        }

    };
    selectedPointSlider = function () {
        $('.partnersSlider-points .paginationPoints-point').removeClass('active');
        $('.partnersSlider-points [data-item=' + _currentlyShownPartner + ']').addClass('active');
    };
    setQuantityParentSlider = function () {
        $('.partnersSlider-points .paginationPoints-point').remove();
        const all = $('.partnersSlider .partnersSlider-item').length;
        const widthLogos = $('.partnersSlider-container').width();
        const widthLogo = 300;
        const showElements = Math.floor(widthLogos / widthLogo);
        const nrPoinst = Math.ceil(all / showElements);
        maxPartner = nrPoinst;
        addPointPartners(nrPoinst);
        setClickParentSlider();
    };
    let touchstart = 0;
    $(window).on('touchstart', function (e) {
        touchstart = e.touches[0].clientX;
    });
    $(window).on('touchend', function (e) {
        touchend(e.changedTouches[0].clientX);
    });
    touchend = function (_value) {
        const _touchend = _value;
        // console.log('_touchend', _touchend, 'touchstart', touchstart);
        let _difference = Math.abs(touchstart - _touchend);
        if (_difference > 50) {
            if (touchstart > _touchend) {
                showNext();
                showNextPartners();
            } else {
                showPrev();
                showPrevPartners();
            }
        }
    };
    showNextPartners = function () {
        movePartnersSlider(_currentlyShownPartner + 1);
        selectedPointSlider();
    };

    showPrevPartners = function () {
        movePartnersSlider(_currentlyShownPartner - 1);
        selectedPointSlider();
    };
    setQuantityParentSlider();
    //----------------------------PLAYER
    let nrFirstVisible = 1;
    const heightItemList = $('.js-player .preview').outerHeight(true);
    const playerMaxVisibleItems = 3;
    const playerMaxItems = $('.js-player .preview').length;
    $('.js-playerArrowUp').click(function () {
        playerPreviousPreview();
    });
    $('.js-playerArrowDown').click(function () {
        playerNextPreview();
    });
    playerNextPreview = function () {
        if (canMoveUP()) {
            nrFirstVisible ++;
            $('.js-payerPreviews').animate({top: - (nrFirstVisible-1) * heightItemList}, 500);
        }
    };
    playerPreviousPreview = function () {
        if (canMoveDOWN()) {
            nrFirstVisible --;
            $('.js-payerPreviews').animate({top: - (nrFirstVisible-1) * heightItemList}, 500);
        }
    };
    canMoveUP = function () {
        if (playerMaxItems - nrFirstVisible >= playerMaxVisibleItems) {
            return true;
        } else {
            return  false;
        }
    }
    canMoveDOWN = function () {
        if (nrFirstVisible > 1) {
            return true;
        } else {
            return  false;
        }
    }
});
